// ==================== COMPONENT OVERRIDES ====================

import { colors } from './colors';

export const components = {
  // Button overrides
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.875rem',
        padding: '10px 24px',
        boxShadow: 'none',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
        },
      },
      contained: {
        background: colors.primary.gradient,
        '&:hover': {
          background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
          boxShadow: `0 10px 15px -3px ${colors.shadows.primary}`,
        },
      },
      outlined: {
        borderWidth: 2,
        borderColor: colors.primary.main,
        color: colors.primary.main,
        '&:hover': {
          background: colors.primary.gradient,
          color: colors.primary.contrastText,
          borderColor: 'transparent',
        },
      },
    },
  },

  // Card overrides
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s ease-in-out',
        border: 'none',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },

  // Paper overrides
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      },
      elevation1: {
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      },
      elevation2: {
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
      },
      elevation3: {
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
      },
    },
  },

  // TextField overrides
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: 12,
          transition: 'all 0.2s ease-in-out',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.primary.main,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.primary.main,
            borderWidth: 2,
          },
        },
      },
    },
  },

  // Chip overrides
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        fontWeight: 500,
      },
      colorPrimary: {
        background: colors.primary.gradient,
        color: colors.primary.contrastText,
      },
    },
  },

  // Tab overrides
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.875rem',
        minHeight: 48,
        borderRadius: '8px 8px 0 0',
      },
    },
  },

  // Dialog overrides
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 20,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      },
    },
  },

  // AppBar overrides
  MuiAppBar: {
    styleOverrides: {
      root: {
        background: colors.background.gradient,
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(10px)',
      },
    },
  },

  // Drawer overrides
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRadius: '0 20px 20px 0',
        border: 'none',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
      },
    },
  },
};
